import React from "react";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
}) => {
  return (
    <tr>
      <td>
        <input
       
          type="text"
          required="required"
          placeholder="Enter namee"
          name="namee"
          value={editFormData.namee}
          onChange={handleEditFormChange}
        ></input>
      </td>
      <td>
        
        {/* <input
         
          type="text"
          required="required"
          placeholder="Enter date"
          name="date"
          value={editFormData.date}
          onChange={handleEditFormChange}
        ></input> */}
         <input 
          id="txtDate" 
          name="name1" 
         
          value={editFormData.name1}
          onChange={handleEditFormChange}></input>
      </td>
      <td>
        <input
         
          type="text"         
          required="required"
          placeholder="Enter day"
          name="day"
          value={editFormData.day}
          onChange={handleEditFormChange}
         ></input>
      </td>
   
      <td>
        <button type="submit">Save</button>
        <button type="button" onClick={handleCancelClick}>
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;